export default __webpack_public_path__ + "static/media/crown-dark.18f77ad6.svg";